var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShoppingbag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1248 8.75V5C13.1248 3.27411 11.7256 1.875 9.99975 1.875C8.27386 1.875 6.87475 3.27411 6.87475 5V8.75M16.3381 7.08936L17.3907 17.0894C17.449 17.6429 17.015 18.125 16.4584 18.125H3.54112C2.98452 18.125 2.5505 17.6429 2.60877 17.0894L3.6614 7.08936C3.71162 6.61222 4.11397 6.25 4.59375 6.25H15.4058C15.8855 6.25 16.2879 6.61222 16.3381 7.08936ZM7.18725 8.75C7.18725 8.92259 7.04734 9.0625 6.87475 9.0625C6.70216 9.0625 6.56225 8.92259 6.56225 8.75C6.56225 8.57741 6.70216 8.4375 6.87475 8.4375C7.04734 8.4375 7.18725 8.57741 7.18725 8.75ZM13.4373 8.75C13.4373 8.92259 13.2973 9.0625 13.1248 9.0625C12.9522 9.0625 12.8123 8.92259 12.8123 8.75C12.8123 8.57741 12.9522 8.4375 13.1248 8.4375C13.2973 8.4375 13.4373 8.57741 13.4373 8.75Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingbag);
export default __webpack_public_path__ + "static/media/shoppingbag.51197bca5c78c9c302405f88017a8c11.svg";
export { ForwardRef as ReactComponent };